import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel, FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import DoneIcon from '@material-ui/icons/Done';
import React, { memo } from 'react';

import CardService from '../service/CardService';

export default memo(({
  field,
  onChange,
  onFileUpload,
}: any) => {
  const uploadFile = (e: any, fieldId: number) => {
    const userId = parseInt(localStorage.getItem('user') || '0', 10);
    CardService.uploadFile(userId, e.target.files[0], fieldId).then(onFileUpload);
  };

  const getField = () => {
    if (field.type.element === 'textfield') {
      return (
        <TextField
          error={field.error}
          label={field.name}
          fullWidth
          onChange={(e) => {
            onChange(e.target.value);
          }}
          required={field.required}
          helperText={field.hint}
        />
      );
    }

    if (field.type.element === 'datepicker') {
      return (
        <TextField
          label={field.name}
          error={field.error}
          type="date"
          defaultValue="2005-06-24"
          InputLabelProps={{
            shrink: true,
          }}
          onChange={(e) => {
            onChange(e.target.value);
          }}
          required={field.required}
          helperText={field.hint}
        />
      );
    }

    if (field.type.element === 'checkbox') {
      return (
        <FormControlLabel
          control={(
            <Checkbox
              onChange={(e) => {
                onChange(e.target.checked);
              }}
              color="primary"
            />
          )}
          label={`${field.name}${field.required ? ' *' : ''}`}
        />
      );
    }

    if (field.type.element === 'select') {
      return (
        <FormControl fullWidth required={field.required}>
          <InputLabel error={field.error}>{ field.name }</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            error={field.error}
            id="demo-simple-select"
            fullWidth
            onChange={(e) => {
              onChange(e.target.value);
            }}
          >
            {
              field.options.map((o: any) => (
                <MenuItem value={o.index} key={o.index}>{o.text}</MenuItem>
              ))
            }
          </Select>
          <FormHelperText>{field.hint}</FormHelperText>
        </FormControl>
      );
    }

    if (field.type.element === 'file' && !CardService.isLocal()) {
      return (
        <div>
          <input
            accept="image/*"
            style={{ display: 'none' }}
            id={`file_${field.id}`}
            multiple
            type="file"
            onChange={(e) => uploadFile(e, field.id)}
          />
          <label htmlFor={`file_${field.id}`}>
            <Button
              variant="contained"
              color="primary"
              component="span"
              startIcon={<CloudUploadIcon />}
              endIcon={field.fileUploaded && <DoneIcon />}
            >
              {field.name}
            </Button>
          </label>
        </div>
      );
    }

    return null;
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={3} />
      <Grid item xs={12} sm={6}>
        {getField()}
      </Grid>
      <Grid item xs={12} sm={3} />
    </Grid>
  );
}, (prevProps, nextProps) => prevProps.field.value === nextProps.field.value
  && prevProps.field.error !== nextProps.field.error);
